// config.js
export default {
    backendUrl: 'https://tdmu.anphuviet.com',
    faceCenterUrl: 'http://118.69.134.147:39019/assets/',
  }
  